const configuredBaseUrl = String(
 import.meta.env.VITE_API_BASE_URL ??"http://localhost:3000").trim();

/**
 * One source of truth for every browser-to-server request.
 *
 * Set VITE_API_BASE_URL to an empty string when the API is served from the
 * same origin, or to an absolute origin such as https://api.example.com.
 */
export const API_BASE_URL = configuredBaseUrl.replace(/\/+$/,"");

export const apiUrl = (path: string): string => {
 const normalizedPath = path.startsWith("/") ? path :`/${path}`;
 return`${API_BASE_URL}${normalizedPath}`;
};
